import { render, staticRenderFns } from "./NexusWithdrawList.vue?vue&type=template&id=46959488&"
import script from "./NexusWithdrawList.vue?vue&type=script&lang=js&"
export * from "./NexusWithdrawList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports